/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2019 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {

  $('.location-filters__toggle-link').on('click', function(e) {
    e.preventDefault();

    // Store the href value
    var $href = $(this).attr("href").slice(1);

    // Check if clicked toggle link has class or not
    if (!$(this).hasClass('current')) {
      $('.location-filters__toggle-link').removeClass('current').attr('aria-selected', 'false');
      $(this).addClass('current').attr('aria-selected', 'true');

      if ($href == 'map-view') {
        $('.location-search__content[aria-labelledby=map-view]').attr('aria-hidden', 'false');
        $('.location-search__content[aria-labelledby=list-view]').attr('aria-hidden', 'true');
      } else if ($href == 'list-view') {
        $('.location-search__content[aria-labelledby=list-view]').attr('aria-hidden', 'false');
        $('.location-search__content[aria-labelledby=map-view]').attr('aria-hidden', 'true');
      }
    }
  });

  function mobileLocations() {
    // Mobile viewport
    var $bp3 = 900;

    // If viewport is smaller than $bp3
    if ($(window).width() < $bp3) {
      // Reset toggle link to list view
      $('.location-filters__toggle-link').removeClass('current').attr('aria-selected', 'false');
      $('.location-filters__toggle-link[href="#list-view"]').addClass('current').attr('aria-selected', 'true');

      // Reset locations to list view
      $('.location-search__content[aria-labelledby=list-view]').attr('aria-hidden', 'false');
      $('.location-search__content[aria-labelledby=map-view]').attr('aria-hidden', 'true');
    }
  }

  // Execute on load and resize
  $(window).on('load', mobileLocations);
  $(window).on('resize', mobileLocations);

})(jQuery);
